import React from "react";

import { cn } from "@/lib/utils";

interface MetricContainerProps {
  value: string;
  className?: string;
}

const MetricContainer: React.FC<MetricContainerProps> = ({
  value,
  className,
}) => {
  return (
    <div
      className={cn(
        "flex items-center justify-center rounded-md text-black text-base font-noto h-8 w-20 bg-gray-200",
        className,
      )}
    >
      {value}
    </div>
  );
};

export { MetricContainer };
